export default __webpack_public_path__ + "static/media/case_4.b6bb53b8.jpg";